import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "../css/Signup.css";

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault(); // 페이지 새로고침 방지

    try {
      const response = await axios.post("http://35.192.131.111/user/login/", {
        username,
        password,
      });

      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("username", username); // 로그인한 사용자의 username 저장
        onLogin(); // 로그인 상태 업데이트
        navigate("/"); // 홈 화면으로 이동
      }
    } catch (error) {
      setError("로그인에 실패했습니다. 아이디와 비밀번호를 확인해주세요.");
      console.error(
        "Error during API request:",
        error.response || error.message
      );
    }
  };

  return (
    <div className="login-box">
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="아이디"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="비밀번호"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">로그인</button>
        {error && <p className="error">{error}</p>}
      </form>
      <p>
        <Link to="/signup">회원가입</Link> |{" "}
        <Link to="/forgot-password">비밀번호 찾기</Link>
      </p>
    </div>
  );
};

export default Login;
